module.exports = __webpack_public_path__ + "UX48.png?9915fb1e3dd37dad2318046274754de5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX48.png
// module id = 99
// module chunks = 0